import { render, staticRenderFns } from "./incidentReportFormattedUnableToWorkDays.vue?vue&type=template&id=21175ca0"
import script from "./incidentReportFormattedUnableToWorkDays.vue?vue&type=script&lang=js"
export * from "./incidentReportFormattedUnableToWorkDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports